import { cloneDeep } from "lodash";

import { SET_PDP_CONTENTFUL_DATA } from "@lululemon/ecom-pdp/src/store/actions/pdp-actions";

const pdpContentful = (state = {}, action) => {
  if (action.type === SET_PDP_CONTENTFUL_DATA) {
    const newState = cloneDeep(state);
    newState[action.productId] = action.data;
    return newState;
  } else {
    return state;
  }
};

export default pdpContentful;
